// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms_terms__3e_Jo","main":"Terms_main__t3qXX","head":"Terms_head__23OTc","top":"Terms_top__1tiJx","sub":"Terms_sub__oLRMS","body":"Terms_body__EgAnN"};